// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/amscr-rsc-crfi-issuance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/amscr-rsc-crfi-issuance/amscr-rsc-crfi-issuance.js';
import g1 from '../lessons/air-law/amscr-rsc-crfi-issuance/rsc-reissue-and-validity.js';

mount([g0, g1]);
